import { type OrderGetOrderDetailsReadDto } from "@/config/apiClient";
import {
  OrderItemStatusEnum,
  RetroplanningStatusEnum,
} from "@/config/apiClient.types";

// Check if the Retroplanning Status is already done by user
export const checkRetroplanningActionAlreadyDone = (
  status: RetroplanningStatusEnum,
  order: OrderGetOrderDetailsReadDto,
  orderItemId: string
): boolean => {
  const orderItem = order.OrderItem.find((oi) => oi.id === orderItemId);

  switch (status) {
    case RetroplanningStatusEnum.QUOTE_TO_VALIDATE:
      return !!orderItem?.sandboxItemQuoteId;
    case RetroplanningStatusEnum.HD_FILE_MISSING:
      return !!orderItem?.sandboxItem?.allSandboxItemVersionsHaveHDFiles;
    case RetroplanningStatusEnum.PROOF_TO_VALIDATE:
      return !!orderItem?.sandboxItem.SandboxItemProof.filter(
        (proof) => !!proof.validatedAt
      ).length;
    case RetroplanningStatusEnum.PURCHASE_ORDER_MISSING:
      return !!order?.purchaseOrders?.length;
    default:
      return false;
  }
};

// Check if the order item is cancelled or finished
export const isOrderItemCancelledOrFinished = (
  order: OrderGetOrderDetailsReadDto,
  orderItemId: string
): boolean => {
  const orderItem = order.OrderItem.find((oi) => oi.id === orderItemId);

  // Check if order item is cancelled or delivered
  if (
    orderItem?.status === OrderItemStatusEnum.CANCELLED ||
    orderItem?.status === OrderItemStatusEnum.DONE
  ) {
    return true;
  }

  return false;
};
